<template>
  <el-container class="home">
    <el-header :class="isStyle2?'header2':'header'">
      <Header
        :slideWidth="slideWidth"
        :isStyle2="isStyle2"
        @menu-trigger-event="menuTriggerEvent"
      ></Header>
    </el-header>
    <el-container :class="isStyle2?'content2':'content'">
      <el-aside :width="slideWidth">
        <SlideMenu :isCollapse="isCollapse"></SlideMenu>
      </el-aside>
      <el-container>
        <el-main style="position: relative">
          <div class="breadcrumb">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item
                v-for="(item, index) in breadcrumbData"
                v-bind:key="index"
                >{{ item.title }}</el-breadcrumb-item
              >
            </el-breadcrumb>
          </div>
          <router-view></router-view>
        </el-main>
        <el-footer>
          <Footer></Footer>
        </el-footer>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import SlideMenu from "@/components/SlideMenu";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default {
  name: "Home",
  data() {
    return {
      breadcrumbData: [],
      slideWidth: "200px",
      isCollapse: false,
      style2Title:'监控运维',
      isStyle2: false
    };
  },
  components: {
    SlideMenu,
    Header,
    Footer
  },
  beforeUpdate() {
    const breadcrumbData = [];
    const matcheds = this.$route.matched;
    for (var i = 0; i < matcheds.length; i++) {
      const matched = matcheds[i];
      const meta = matched.meta;
      if (!meta.title) {
        continue;
      }
      const item = {
        title: meta.title
      };
      
      breadcrumbData.push(item);
    }
    if(breadcrumbData.length > 1 && this.style2Title == breadcrumbData[1].title) {
      this.isStyle2 = true;
    } else {
      this.isStyle2 = false;
    }
    this.breadcrumbData = breadcrumbData;
  },
  methods: {
    menuTriggerEvent: function(triggerType) {
      if (triggerType == "close") {
        this.isCollapse = true;
        this.slideWidth = "65px";
      } else {
        this.isCollapse = false;
        this.slideWidth = "200px";
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "./Home.less";
</style>



// WEBPACK FOOTER //
// src/views/Home.vue